import React from "react";

interface Props {
  color?: string;
}

const Cross = ({ color = "white" }: Props) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.242 2.47115L12.5659 0.795044L1.46172 11.8992L3.13783 13.5753L14.242 2.47115Z"
      fill={color}
    />
    <path
      d="M14.2421 11.9733L3.13794 0.86911L1.46183 2.54522L12.566 13.6494L14.2421 11.9733Z"
      fill={color}
    />
  </svg>
);

export default Cross;
